// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid-control-alert-body {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: #000;
}

.grid-control-alert-button {
    background-color: #00a9a4;
    color: #fafafa;
    border-radius: 24px;
}
`, "",{"version":3,"sources":["webpack://./client/components/product-collection/footer/components/grid-control-alert.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,mBAAmB;AACvB","sourcesContent":[".grid-control-alert-body {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n    color: #000;\n}\n\n.grid-control-alert-button {\n    background-color: #00a9a4;\n    color: #fafafa;\n    border-radius: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
